{
  "header": {
    "title": "Frågebibliotek",
    "description": "Hantera dina feedbackkategorier och frågor",
    "addCategoryButton": "Lägg till kategori"
  },
  "searchInput": {
    "placeholder": "Sök frågor"
  },
  "delete": {
    "title": "Radera kategori",
    "description": "Är du säker på att du vill radera denna kategori? Denna åtgärd kan inte ångras och alla associerade frågor och svar tas bort permanent.",
    "deleteButton": "Radera kategori",
    "cancelButton": "Avbryt"
  },
  "translationOverview": {
    "title": "Översättning till andra språk",
    "description": "Vi använder AI-översättning, så resultatet kan innehålla fel"
  },
  "detailsPage": {
    "header": {
      "backButton": "Tillbaka till frågekategorier",
      "questionsCount": "{{questionsCount}} frågor",
      "addQuestionButton": "Lägg till fråga"
    },
    "searchInput": {
      "placeholder": "Sök frågor"
    },
    "sortDropdown": {
      "triggerLabel": "Sortera efter",
      "options": {
        "questionQuantity": "Antal frågor",
        "fromNewestToOldest": "Från nyast till äldst",
        "fromOldestToNewest": "Från äldst till nyast"
      }
    },
    "delete": {
      "title": "Radera fråga",
      "description": "Är du säker på att du vill radera denna fråga? Denna åtgärd kan inte ångras och alla associerade svar tas bort permanent.",
      "deleteButton": "Radera fråga",
      "cancelButton": "Avbryt"
    },
    "translationOverview": {
      "title": "Översättning till andra språk",
      "description": "Vi använder AI-översättning, så resultatet kan innehålla fel"
    }
  }
}
